"use strict";
import { SITE_BRAND_ADD, SITE_BRAND_CLEAN } from "@/store/mutation-types";
import _ from "lodash";
import Vue from "vue";
// "title": "CN",
//   "about": "",
//   "links": [

//   ],
//   "logo_attachment_id": "5dc22bfac37e9b3b1e1d7a34",
//   "cover_image_attachment_id": "",
//   "homepage_url": "www.thecn.com",
//   "heading": "TestCnSite",
//   "hidden": false,
//   "expiration_time": "1575043200",
//   "signup_setting_type": "email_suffix",
//   "signup_setting_args": {
//     "value": "coursenetworking.com"
//   },
//   "signup_setting_hint": "Hello CN Users",
const SIGNUP_SETTING_TYPE_NO_ONE = "no_one";
const SIGNUP_SETTING_TYPE_ANY_ONE = "any_one";
const SIGNUP_SETTING_TYPE_EMAIL_SUFFIX = "email_suffix";
const SIGNUP_SETTING_TYPE_PIN_CODE = "pin_code";
const DEFAULT_BRAND = {
  brand: "",
  title: "",
  links: [],
  count: { users: 0 },
  cover_image_url: "",
  logo_attachment_url: "",
  homepage_url: "",
  heading: "",
  hidden: false,
  expiration_time: null,
  signup_setting_type: "",
  //   public $signup_setting_args = array('value' => '');
  signup_setting_value: "",
  signup_setting_hint: "",
  signin_redirection_page: "",
  signin_placeholder_of_username: "",
  signin_placeholder_of_password: "",
  signin_link_of_forgot_password: "",
  user_labels: [],
};
const state = Object.assign({}, DEFAULT_BRAND);

const mutations = {
  [SITE_BRAND_ADD](state, payload) {
    state.brand = payload.brand;
    state.title = payload.title;
    state.links = payload.links;
    state.homepage_url = payload.homepage_url;
    state.cover_image_url = _.get(payload, "cover_image_attachment.view_url");
    state.logo_attachment_url = _.get(payload, "logo_attachment.view_url");
    state.signup_setting_value = _.get(payload, "signup_setting_args.value");
    state.heading = payload.heading;
    state.hidden = payload.hidden;
    state.expiration_time = payload.expiration_time;
    state.signup_setting_type = payload.signup_setting_type;
    state.signup_setting_hint = payload.signup_setting_hint;
    state.signin_redirection_page = payload.signin_redirection_page;
    state.signin_placeholder_of_username =
      payload.signin_placeholder_of_username;
    state.signin_placeholder_of_password =
      payload.signin_placeholder_of_password;
    state.signin_link_of_forgot_password =
      payload.signin_link_of_forgot_password;
    state.count = payload.count;
    state.user_labels = payload.user_labels;
  },
  [SITE_BRAND_CLEAN](state) {
    state = Object.assign({}, DEFAULT_BRAND);
  },
};

// context = {
//     state,      // `store.state`，
//     rootState,  // `store.state`，
//     commit,     // `store.commit`
//     dispatch,   // `store.dispatch`
//     getters,    // `store.getters`
//     rootGetters // `store.getters`
// }
const actions = {
  // fix the undefined variable $api in API site_brand_signup_user_check
  // 'email'=>'string, email address',
  //  *     'signup_site_brand'=>'string, the name of site brand',
  //  *     'signup_site_brand_pin_code'=>'string, the institution code',
  checkUserSignup(context, payload) {
    const { commit, state } = context;
    const { email, pinCode } = payload;
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`site_brand_signup_user_check`, {
          params: {
            email: email,
            signup_site_brand_pin_code: pinCode,
            signup_site_brand: state?.brand,
          },
        })
        .then((ctx) => {
          const { data } = ctx;
          resolve(data);
        })
        .catch(reject);
    });
  },
  setupBrand(context, brandName) {
    const { commit } = context;
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`site_brand`, {
          params: {
            brand: brandName,
            with_site_brand_logo_attachment: 1,
            with_site_brand_cover_image_attachment: 1,
            with_site_brand_count_users: 1,
            with_site_brand_count_institution_users: 1,
            with_site_brand_user_labels: 1,
          },
        })
        .then((ctx) => {
          const { data } = ctx;
          let brandData = _.get(data, "data[0]");
          if (brandData) {
            commit(SITE_BRAND_ADD, brandData);
          }
          resolve(data);
        })
        .catch(reject);
    });
  },
};

// state,       // all state
// getters,     // store.getters
// rootState    // store.state
// rootGetters  // getters
const getters = {
  isTypeCode(state, getters, rootState, rootGetters) {
    return SIGNUP_SETTING_TYPE_PIN_CODE === state.signup_setting_type;
  },
  enabledUserLabelSelfSelection(state, getters, rootState, rootGetters) {
    return !_.isEmpty(state.user_labels);
  },
  userLabels(state, getters, rootState, rootGetters) {
    let userLabels = state.user_labels || [];
    userLabels = userLabels.map((label) => {
      return {
        value: label,
        text: label,
      };
    });
    return [{ value: null, text: "Please Select One" }].concat(userLabels);
  },
  isTypeEmail(state, getters, rootState, rootGetters) {
    return SIGNUP_SETTING_TYPE_EMAIL_SUFFIX === state.signup_setting_type;
  },
  isDisabled(state, getters, rootState, rootGetters) {
    return state.hidden || getters.isExpired;
  },
  isExpired(state, getters, rootState, rootGetters) {
    return state.expiration_time && +new Date() / 1e3 > state.expiration_time;
  },
  isTypeNoOne(state, getters, rootState, rootGetters) {
    return (
      SIGNUP_SETTING_TYPE_NO_ONE === state.signup_setting_type ||
      state.hidden ||
      (state.expiration_time && +new Date() / 1e3 > state.expiration_time)
    );
  },
  isTypeAnyOne(state, getters, rootState, rootGetters) {
    return SIGNUP_SETTING_TYPE_ANY_ONE === state.signup_setting_type;
  },
  getSignupEmailHint(state, getters, rootState, rootGetters) {
    if (getters.isTypeEmail) {
      return state.signup_setting_value;
    }
    return null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
